import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Router } from "@reach/router";
import { Redirect } from "@reach/router";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Redirect from="/" to="/intro" />
    <App path="/:lessonId" />
  </Router>
);
